namespace Portico.Services {

    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;
    import pme = Portico.Models.Enterprise;

    @Service('app', 'locationServiceClient')
    @Inject('apiService', 'spinnerOverrideService')
    export class LocationServiceClient implements ILocationService {
        constructor(
            private apiService: IApiService,
            private spinnerOverrideService: ISpinnerOverrideService
        ) { }

        getCities(zip: string): angular.IPromise<pme.City[]> {
            const endpoint = `/locationzip?zip=${zip}`;

            const promise = this.spinnerOverrideService.withoutUntil<pme.City[]>(() => this.apiService.getItem<pme.City[]>(endpoint));

            return promise.then((response: pme.City[]) => {
                const temp: pme.City[] = [];

                for (const city of response) {
                    temp.push(new pme.City(city));
                }

                return temp;
            });
        }

        getStates(): angular.IPromise<pme.State[]> {
            const endpoint = `/locationstate`;

            const promise = this.apiService.getItem<pme.State[]>(endpoint);

            return promise.then((response: pme.State[]) => {
                const temp: pme.State[] = [];

                for (let i = 0; i < response.length; i++) {
                    const state = response[i];
                    const length = state.description.length;

                    if (state.description.charAt(length - 1) === '.') {
                        state.description = state.description.substring(0, length - 1);
                    }

                    if (state.description !== 'UNKNOWN') {
                        temp.push(new pme.State(state));
                    }
                }

                return temp;
            });
        }

        getSuggestedAddress(address: pme.Address): angular.IPromise<pme.IPartialAddress[]> {
            throw "not implemented, use LocationService class instead";
        }
    }
}